module.exports = __webpack_public_path__ + "img/footerLogo.a0589406.svg";